import React, { useState, useEffect, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Input, Form } from 'reactstrap';
import { AppContext } from '../../application/provider';
import PagosPlanillaService from '../../axios_services/pagosplanilla.service';
import Loader from '../Loader/Loader';

const ModalBonosPlanilla = ({ isOpen, onClose, onRefresh }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [areaFilter, setAreaFilter] = useState('1'); 
    const [perfilFilter, setPerfilFilter] = useState('');
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState('');
    const [tipoBono, setTipoBono] = useState('1'); 
    const [montoBono, setMontoBono] = useState('');
    
    const [usuariosList, setUsuariosList] = useState([]);
    const [hasBonus, setHasBonus] = useState(false);

    const perfiles = state.catalogos?.perfiles || [];
    const filteredPerfiles = perfiles.filter(p => String(p.macro_area_id) === String(areaFilter));

    useEffect(() => {
        if (isOpen) {
            if (filteredPerfiles.length > 0 && (!perfilFilter || !filteredPerfiles.some(p => String(p.perfil_id) === String(perfilFilter)))) {
                setPerfilFilter(String(filteredPerfiles[0].perfil_id));
            }
        }
    }, [isOpen, areaFilter]);

    useEffect(() => {
        if (isOpen && areaFilter && perfilFilter) {
            loadUsuarios();
        }
    }, [isOpen, areaFilter, perfilFilter]);

    useEffect(() => {
        if (usuarioSeleccionado && tipoBono) {
            checkCurrentBonus();
        } else {
            setMontoBono('');
            setHasBonus(false);
        }
    }, [usuarioSeleccionado, tipoBono]);

    const loadUsuarios = async () => {
        setIsLoading(true);
        try {
            const resp = await PagosPlanillaService.getColaboradoresConfig(areaFilter, perfilFilter);
            const users = resp.data.data || [];
            setUsuariosList(users);
            if (users.length > 0) {
                setUsuarioSeleccionado(users[0].usuario_id);
            } else {
                setUsuarioSeleccionado('');
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const checkCurrentBonus = async () => {
        setIsLoading(true);
        try {
            const resp = await PagosPlanillaService.getBonosConfig(areaFilter, perfilFilter, tipoBono);
            const data = resp.data.data || [];
            const userBono = data.find(r => String(r.usuario_id) === String(usuarioSeleccionado));
            if (userBono && userBono.monto_bono !== null) {
                setMontoBono(userBono.monto_bono);
                setHasBonus(true);
            } else {
                setMontoBono('');
                setHasBonus(false);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSave = async () => {
        if (!usuarioSeleccionado || montoBono === '' || isNaN(montoBono)) {
            alert('Por favor complete todos los campos.');
            return;
        }

        setIsLoading(true);
        try {
            await PagosPlanillaService.updateBono({
                usuario_id: usuarioSeleccionado,
                tipo_bono: tipoBono,
                monto_bono: parseFloat(montoBono)
            });
            alert('Bono registrado correctamente.');
            if (onRefresh) onRefresh();
            onClose();
        } catch (e) {
            console.error(e);
            alert('Error al registrar bono.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>GESTIÓN DE BONOS - PLANILLA</h1>
                    <button className="close-btn" onClick={onClose}>X</button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body p-4">
                    {isLoading && <Loader />}
                    
                    <p className="text-muted mb-4 px-4" style={{ fontSize: '12px', lineHeight: '1.2' }}>
                        Seleccione el colaborador y configure el bono correspondiente.
                    </p>

                    <Form onSubmit={(e) => { e.preventDefault(); handleSave(); }} className="px-4">
                        <FormGroup className="mb-3">
                            <Label>Área:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={areaFilter}
                                onChange={(e) => setAreaFilter(e.target.value)}
                            >
                                <option value="1">ADMINISTRACIÓN</option>
                                <option value="2">NEGOCIOS</option>
                                <option value="4">GERENCIA</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label>Perfil:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={perfilFilter}
                                onChange={(e) => setPerfilFilter(e.target.value)}
                            >
                                {filteredPerfiles.map(p => (
                                    <option key={p.perfil_id} value={p.perfil_id}>{p.descripcion.toUpperCase()}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label>Usuario:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={usuarioSeleccionado}
                                onChange={(e) => setUsuarioSeleccionado(e.target.value)}
                            >
                                {usuariosList.length > 0 ? usuariosList.map(u => (
                                    <option key={u.usuario_id} value={u.usuario_id}>{u.nombre_completo.toUpperCase()}</option>
                                )) : (
                                    <option value="">No hay usuarios</option>
                                )}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label>Tipo de Bono:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={tipoBono}
                                onChange={(e) => setTipoBono(e.target.value)}
                            >
                                <option value="1">BONO ANUAL</option>
                                <option value="2">BONO POR GESTIÓN</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-4">
                            <Label>Monto Bono (S/):</Label>
                            <Input 
                                type="number" 
                                placeholder="0.00"
                                value={montoBono}
                                onChange={(e) => setMontoBono(e.target.value)}
                            />
                            {hasBonus && (
                                <div className="text-success mt-1" style={{ fontSize: '10px' }}>
                                    ✓ Este usuario ya tiene un bono registrado de este tipo.
                                </div>
                            )}
                        </FormGroup>

                        <div className="flex justify-end mt-4 pb-3">
                            <Button className="btn-primary px-5 py-2" onClick={handleSave} style={{ borderRadius: '8px' }}>
                                REGISTRAR
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalBonosPlanilla;
